import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

export interface AdmissionCardDescriptionProps {
  description?: string | null;
  isDateVisible: boolean;
  onlinePrice?: number;
  ddpPrice?: number;
  formattedSalesEndsDate?: string;
  formattedOnlinePrice?: string;
  formatedDdpPrice?: string;
}

export const AdmissionCardDescription = ({
  description,
  isDateVisible,
  onlinePrice,
  ddpPrice,
  formattedSalesEndsDate,
  formattedOnlinePrice,
  formatedDdpPrice,
}: AdmissionCardDescriptionProps) => {
  const { t } = useTranslation();

  if (!description && !isDateVisible && !onlinePrice && !ddpPrice) {
    return null;
  }

  return (
    <div
      className={classNames('flex flex-col gap-1 w-full min-w-0', {
        'hidden sm:flex': !onlinePrice && !ddpPrice,
      })}>
      {description && (
        <p className='hidden sm:block text-secondary text-body-xs text-left w-full min-w-0 whitespace-nowrap overflow-hidden text-ellipsis'>
          {String(description).slice(0, 250)}
        </p>
      )}
      {(!!onlinePrice || !!ddpPrice || isDateVisible) && (
        <p className='flex items-center gap-2 sm:gap-4'>
          {isDateVisible && (
            <span className='hidden sm:block text-body-xs text-tertiary'>
              {t('common:admissionCardSalesEndsAt', {
                time: formattedSalesEndsDate,
              })}
            </span>
          )}
          {!!onlinePrice && (
            <>
              {isDateVisible && <span className='hidden sm:block text-body-xs text-tertiary'>|</span>}
              <span className='text-body-xs text-tertiary'>
                {t('offers:downpayment')}: {formattedOnlinePrice}
              </span>
            </>
          )}
          {!!ddpPrice && (
            <>
              {(isDateVisible || !!onlinePrice) && (
                <span
                  className={classNames('text-body-xs text-tertiary', {
                    'hidden sm:block': !onlinePrice,
                  })}>
                  |
                </span>
              )}
              <span className='text-body-xs text-tertiary'>{`${t('offers:admissionDDPLabel')}: ${formatedDdpPrice}`}</span>
            </>
          )}
        </p>
      )}
    </div>
  );
};
